import { config } from "@/config";
import { useFlow } from "@frigade/react";
import * as Frigade from "@frigade/react";
import { OnboardingSteps } from "../OnboardingGuide";
import OnboardingFlow from "./OnboardingFlow";

const OnboardingRubricAnnouncementFlow = () => {
  const { flow } = useFlow(config.frigade.flows.gettingStarted);
  const currentStep = flow?.getCurrentStep();

  if (
    !flow?.isCompleted &&
    (currentStep?.id as OnboardingSteps) === "generate_report"
  ) {
    return (
      <OnboardingFlow>
        <Frigade.Announcement
          flowId={config.frigade.flows.rubricViewAnnouncement}
        />
      </OnboardingFlow>
    );
  }
};

export default OnboardingRubricAnnouncementFlow;
